import styles from "./contacts.module.scss"

export const Contacts = ()=>{
    return <div className={styles.container}>
        <table>
            <tbody>
                <tr>
                    <td className={styles.columnTitle}>Company Registration Number</td>
                    <td>C 106978</td>
                </tr>
                <tr>
                    <td className={styles.columnTitle}>Address</td>
                    <td>
                        <p>Office 9 & Office 10,</p>
                        <p>The Peak Business Centre</p>
                        <p>Triq Santa Katerina,</p>
                        <p>ATD2486 Attard, Malta</p>
                    </td>
                </tr>
                <tr>
                    <td className={styles.columnTitle}>VAT Number</td>
                    <td>Exempted from registration</td>
                </tr>
                <tr>
                    <td className={styles.columnTitle}>Tax Number</td>
                    <td>971 841 720</td>
                </tr>
            </tbody>
        </table>
    </div>
}